import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import { formatWithLocale } from "../../../helpers/format";
import { useViewport } from '../../../helpers';
import { useTranslation } from "react-i18next";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  CircularProgress,
} from "@mui/material";
import { Typography, TextField } from "@mui/material";
import { zoneService } from "../../../services";
import { useSnackbar } from "notistack";
import SaveIcon from '@mui/icons-material/Save';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// import DateFnsUtils from "@date-io/date-fns";
import ConfirmationDialog from "../../../components/dialog/ConfirmationDialog";
import { useEffect } from "react";
import LineChart from "../../../components/charts/LineChart";
import BarChart from "../../../components/charts/BarChart";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from "dayjs";
import i18next from "i18next";

const PREFIX = 'Statistics';

const classes = {
  root: `${PREFIX}-root`,
  input: `${PREFIX}-input`,
  tooltip: `${PREFIX}-tooltip`,
  tooltipTitle: `${PREFIX}-tooltipTitle`,
  tooltipActivations: `${PREFIX}-tooltipActivations`,
  titleStatistics: `${PREFIX}-titleStatistics`,
  zones: `${PREFIX}-zones`,
  resetStatsContainer: `${PREFIX}-resetStatsContainer`,
  marginRight: `${PREFIX}-marginRight`,
  resetButton: `${PREFIX}-resetButton`,
  textField: `${PREFIX}-textField`,
  specifyHintContainer: `${PREFIX}-specifyHintContainer`,
  saveIcon: `${PREFIX}-saveIcon`,
  manageStatContainer: `${PREFIX}-manageStatContainer`,
  loadingStatsContainer: `${PREFIX}-loadingStatsContainer`,
  marginBottom: `${PREFIX}-marginBottom`,
  selectMenuStyle: `${PREFIX}-selectMenuStyle`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.tooltip}`]: {
    backgroundColor: '#333444 !important',
    color: theme.palette.primary.main,
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    borderRadius: '1rem',
    margin: '1rem,',
    textAlign: "center",
  },

  [`& .${classes.tooltipTitle}`]: {
    padding: '0.5rem',
  },

  [`& .${classes.tooltipActivations}`]: {
    fontWeight: "bold",
    padding: '0.2rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  },

  [`& .${classes.titleStatistics}`]: {
    display: "inline-block",
    marginTop: '16px',
    color: '#fff',
    opacity: '0.8',
    marginBottom: '1rem'
  },

  [`& .${classes.zones}`]: {
    minWidth: '150px',
    margin: '1rem 0 0 1rem',
    maxWidth: '50vw',
  },

  [`& .${classes.resetStatsContainer}`]: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'row',
  },

  [`& .${classes.marginRight}`]: {
    marginRight: '1rem',
  },

  [`& .${classes.resetButton}`]: {
    height: 'calc(100% - 12px)',
    marginTop: '15px',
  },

  [`& .${classes.textField}`]: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },

  [`& .${classes.specifyHintContainer}`]: {
    marginTop: '1rem',
    display: 'flex',
    '&:input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
      color: theme.palette.primary.main,
      opacity: 1,
      display: 'block',
      width: '20px',
      height: '20px',
      borderWidth: 'thin',
    },
  },

  [`& .${classes.saveIcon}`]: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    transform: 'scale(0.6)',
  },

  [`& .${classes.manageStatContainer}`]: {
    marginTop: '1rem',
    marginBottom: '1rem'
  },

  [`& .${classes.loadingStatsContainer}`]: {
    textAlign: 'center',
    paddingTop: '6rem'
  },

  [`& .${classes.marginBottom}`]: {
    marginBottom: '4rem'
  },

  [`& .${classes.selectMenuStyle}`]: {
    backgroundColor: '#424242'
  }
}));

export default function Statistics(props) {
  const { t, i18n } = useTranslation();
  const { width } = useViewport();
  window.__localeId__ = i18n.language;
  const [filteredZones1, setFilteredZones1] = React.useState([]);
  const [filteredZones2, setFilteredZones2] = React.useState("");
  const [zoneStat, setZoneStat] = useState(null);
  const [resetStats, setResetStats] = useState(props.stats);
  const [confirmation, setConfirmation] = useState(null);
  const [filteredStats, setFilteredStats] = useState(props.stats);
  const [saving, setSaving] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [statDate, setStatDate] = useState(formatWithLocale(new Date(), 'yyyy-MM-dd\'T\'HH:mm'));
  const [hint, setHint] = useState(0);
  let beginDate = new Date();
  beginDate.setMonth(beginDate.getMonth() - 1);
  beginDate.toLocaleDateString();
  const [filters, setFilters] = React.useState({
    beginDate: beginDate,
    endDate: new Date(),
  });

  const [formatingData, setFormatingData] = useState({
    barComponent: false,
    lineComponent: false,
  });

  useEffect(() => {
    setFilteredZones1([]);
    setFilteredZones2("");
  }, [props.selectedTarget])

  function handleChange(e) {
    if (e.target.value.length > 0) {
      setFilteredZones1(e.target.value);
      const newZones = props.zones.filter((z) => {
        return e.target.value.includes(z.id)
      });
      props.setData(newZones.map((z) => ({
        zone: `${z.label}`,
        activations: z.redirectCount || 0,
        activationsColor: "rgba(175, 39, 25, 1)",
      })));
    } else {
      setFilteredZones1([]);
      props.setData(props.resetStats);
    }
  }

  function handleChange2(e) {
    setFilteredZones2(e.target.value);
    if (e.target.value === "") {
      const tmp = resetStats[0].data.filter(item => {
        return new Date(item.date) >= filters.beginDate && new Date(item.date) <= filters.endDate
      });
      setFilteredStats([{ id: 'stats', data: tmp }]);
    } else {
      const zoneSelected = props.zones.find((z) => z.id === e.target.value)
      zoneService.fetchStatsForOneZone(props.selectedTarget.frameId, props.selectedTarget.label, zoneSelected.index)
        .then((values) => {
          if (values) {
            props.setStats(() => {
              const formatStats = values.map((stat) => {
                const formatDate = formatWithLocale(stat.redirectDate.substring(0, 10), 'P');
                return { x: formatDate, y: stat.redirectCount, date: stat.redirectDate.substring(0, 10) };
              });
              return [{
                id: 'stats',
                data: formatStats,
              }]
            });
          }
        });
    }
  }
  function handleDateChange(name, value) {
    if (value) {
      setFilters({
        ...filters,
        [name]: value,
      });
    }
  }

  React.useEffect(() => {
    setFormatingData({ ...formatingData, lineComponent: true });
    const tmp = props.stats[0].data.filter(item => {
      return new Date(item.date) >= filters.beginDate && new Date(item.date) <= filters.endDate
    });
    let agreg = [];
    if (tmp.length > 25) {
      tmp.forEach(item => {
        const current = new Date(item.date)
        const getWeek = () => {
          var onejan = new Date(current.getFullYear(), 0, 1);
          return Math.ceil((((current - onejan) / 86400000) + onejan.getDay() + 1) / 7);
        }
        const weekNumber = getWeek();
        if (agreg.length === 0)
          agreg.push({ x: `${t('stats.week')} ${weekNumber}`, y: item.y, date: item.date })
        else {
          const index = agreg.length - 1;
          if (agreg[index].x === `${t('stats.week')} ${weekNumber}`)
            agreg[index].y += item.y;
          else
            agreg.push({ x: `${t('stats.week')} ${weekNumber}`, y: item.y, date: item.date })
        }
      })
    }
    setFilteredStats([{ id: 'stats', data: agreg.length === 0 ? tmp : agreg }]);
  }, [filters, props.stats])

  useEffect(() => {
    setFormatingData({ ...formatingData, barComponent: true });
  }, [props.data]);

  useEffect(() => {
    if (formatingData.lineComponent || formatingData.barComponent)
      setTimeout(() => setFormatingData({ lineComponent: false, barComponent: false }), 500);
  }, [formatingData.lineComponent, formatingData.barComponent])

  return (
    <Root>
      <div>
        <div>
          <Typography variant="h5" className={classes.titleStatistics}>{t("myDesign.stats.titleStatisticsByZone")}</Typography>
          <FormControl className={classes.zones}>
            <InputLabel id="select-zone-label">{t("myDesign.stats.filterZones")}</InputLabel>
            <Select
              labelId="select-zone-label"
              id="select-zone-1"
              label={t("myDesign.stats.filterZones")}
              value={filteredZones1}
              onChange={handleChange}
              multiple
              MenuProps={{ classes: { paper: classes.selectMenuStyle } }}
            >
              {props.zones && props.selectedTarget && props.zones.filter((z) => z.target === props.selectedTarget.label).map((z) => (
                <MenuItem key={z.id} value={z.id}>{z.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div style={{ width: width >= 767 ? '50%' : 'inherit' }}>
          {formatingData.barComponent ?
            <div className={classes.loadingStatsContainer}>
              <CircularProgress size={50} />
            </div>
            :
            <BarChart
              data={props.data}
              responsive={width < 767}
            />
          }
        </div>
        {props.isAdmin &&
          <div className={classes.manageStatContainer}>
            <ConfirmationDialog
              open={confirmation ? true : false}
              setOpen={() => setConfirmation(null)}
              element={{ displayName: confirmation }}
              onAgree={() =>
                zoneService.setManualStat(
                  zoneStat,
                  () => enqueueSnackbar(t('toasts.updateManualStatSuccess'), { variant: 'success', }),
                  () => enqueueSnackbar(t('toasts.updateManualStatError'), { variant: 'error', }),
                  () => props.fetchStats(),
                )
                  .then(() => {
                    setSaving(false);
                  }
                  )}
              mode="resetStat"
            />
            <Typography variant="h6">{t("myDesign.stats.manageStats")}</Typography>
            <div className={classes.resetStatsContainer}>
              <FormControl className={classes.marginRight} sx={{width: '100%', maxWidth: '350px'}}>
                <InputLabel
                  id="demo-customized-select-label"
                  sx={{
                    marginLeft: zoneStat && '1rem',
                    transform: zoneStat && 'translate(-3px, 7px) scale(0.8)',
                  }}
                >{t("myDesign.stats.zonePlaceholder")}</InputLabel>
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  label={t("myDesign.stats.zonePlaceholder")}
                  value={zoneStat}
                  onChange={(e) => setZoneStat(e.target.value)}
                  style={{
                    marginTop: zoneStat && '1rem',
                    width: '100%',
                    maxWidth: '350px'
                  }}
                  MenuProps={{ classes: { paper: classes.selectMenuStyle } }}
                >
                  {props.zones && props.selectedTarget && props.zones.filter((z) => z.target === props.selectedTarget.label).map((z) => (
                    <MenuItem key={z.id} value={z.id}>{z.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              {zoneStat &&
                <Button
                  color="primary"
                  variant="outlined"
                  className={classes.resetButton}
                  disabled={saving}
                  onClick={() => setConfirmation(props.zones.filter((z) => z.id === zoneStat)[0].label)}
                >
                  {t("myDesign.stats.resetButton")}
                </Button>
              }
            </div>
            {zoneStat &&
              <div className={classes.specifyHintContainer}>
                <TextField
                  id="datetime-local"
                  label={t("myDesign.stats.customStatDate")}
                  type="datetime-local"
                  value={statDate}
                  onChange={e => setStatDate(e.target.value)}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  id="hint-number"
                  label={t("myDesign.stats.activationsNumber")}
                  type="number"
                  value={hint}
                  onChange={e => setHint(e.target.value)}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Button
                  color="primary"
                  component="span"
                  className={classes.saveIcon}
                  onClick={() =>
                    zoneService.setManualStat(
                      zoneStat,
                      () => enqueueSnackbar(t('toasts.updateManualStatSuccess'), { variant: 'success', }),
                      () => enqueueSnackbar(t('toasts.updateManualStatError'), { variant: 'error', }),
                      () => props.fetchStats(),
                      { hint, date: formatWithLocale(dayjs(statDate), 'P') }
                    )
                      .then(() => {
                        setSaving(false);
                      }
                      )}
                >
                  <SaveIcon style={{ color: '#000', width: '50px', height: '50px' }} />
                </Button>
              </div>
            }
          </div>
        }
      </div>
      <div>
        <div>
          <Typography variant="h5" className={classes.titleStatistics}>{t("myDesign.stats.titleStatisticsByDate")}</Typography>
          <div style={{ display: 'flex', flexDirection: width <= 767 ? 'column' : 'row', marginLeft: '1rem' }}>
            {/* <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locales[i18n.languages[1]]}> */}
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18next.language.substring(0, 2)}>
              <div style={{ marginRight: width > 767 && '2rem' }}>
                {/* <KeyboardDatePicker
                  margin="normal"
                  id="from-date-picker-dialog-date"
                  label={t("stats.from")}
                  format="P"
                  value={filters.beginDate}
                  onChange={(e) => handleDateChange('beginDate', e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  maxDate={filters.endDate}
                /> */}
                <DatePicker
                  id="from-date-picker-dialog-date"
                  label={t("stats.from")}
                  onChange={(e) => handleDateChange('beginDate', e)}
                  value={dayjs(filters.beginDate)}
                  maxDate={dayjs(filters.endDate)}
                />
              </div>
              <div>
                {/* <KeyboardDatePicker
                  margin="normal"
                  id="to-date-picker-dialog-date"
                  label={t("stats.to")}
                  format="P"
                  value={filters.endDate}
                  onChange={(e) => handleDateChange('endDate', e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  minDate={filters.beginDate}
                /> */}
                <DatePicker
                  id="to-date-picker-dialog-date"
                  label={t("stats.to")}
                  onChange={(e) => handleDateChange('endDate', e)}
                  value={dayjs(filters.endDate)}
                  minDate={dayjs(filters.beginDate)}
                />
              </div>
              {/* </MuiPickersUtilsProvider> */}
            </LocalizationProvider>
          </div>
          <FormControl className={classes.zones}>
            <InputLabel id="select-label-2">{t("myDesign.stats.filterZone")}</InputLabel>
            <Select
              labelId="select-label-2"
              id="select-zone-2"
              label={t("myDesign.stats.filterZone")}
              value={filteredZones2}
              onChange={handleChange2}
              MenuProps={{ classes: { paper: classes.selectMenuStyle } }}
            >
              <MenuItem value="">
                <em>{t("stats.none")}</em>
              </MenuItem>
              {props.zones && props.selectedTarget && props.zones.filter((z) => z.target === props.selectedTarget.label).map((z) => (
                <MenuItem key={z.id} value={z.id}>{z.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {
          filteredStats[0].data.length === 0 ?
            <Typography variant="body1" style={{ marginTop: '2rem' }}>{t("stats.noResults")}</Typography>
            :
            <div className={classes.marginBottom} style={{ width: width >= 767 ? '50%' : 'inherit' }}>
              {formatingData.lineComponent ?
                <div className={classes.loadingStatsContainer}>
                  <CircularProgress size={50} />
                </div>
                :
                <LineChart
                  stats={filteredStats[0].data}
                  title={t('myDesign.stats.ActivationTitle')}
                  responsive={width < 767}
                />
              }
            </div>
        }
      </div>
    </Root>
  );
}
